module.exports = __webpack_public_path__ + "media/white-label/contact-t-e43ccf57.png";